import React, {useEffect} from "react";
import Header from "../../components/Header.js";
import {FormattedMessage} from 'react-intl';
import * as StorageService from "../../services/StorageService.js";
import {FIREBASE_SCREEN_NAMES, HEADER_SIZE, LOCALSTORAGE_ITEMS, USER_TYPES} from "../../util/Constants.js";
import analyticsLogEvent from "../../services/FirebaseService";
import {PATH} from "../../routes/routes";
import {useNavigate} from "react-router";


function LoginOrContinueAsGuest(props) {
    const navigateTo = useNavigate();
    const hasBackButton = StorageService.getItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON) === "true" ? true : false;
    const toLoginPage = () => {
        //TODO useNavigate with search params
        navigateTo({
            pathname:  PATH.LOGIN,
            search: "?redirect="+props.redirectUrlAfterLogin,
        });
    }

    const continueAsGuest = async () => {
        StorageService.setItem(LOCALSTORAGE_ITEMS.CONTINUE_AS_GUEST, true);
        StorageService.setItem(LOCALSTORAGE_ITEMS.USER_TYPE, USER_TYPES.ANONYMOUS);
        props.setContinueAsGuest();
    }


    useEffect(() => {
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.LOGIN_OR_CONTINUE_AS_GUEST,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.LOGIN_OR_CONTINUE_AS_GUEST
        });
    }, []);




    return (
        <>
            <Header
                headerSize={HEADER_SIZE.SMALL}
                headerTitle={""}
                hasBackBtn={hasBackButton}
                hasModal={false}
            />


            <main className="page-content login-or-continue-as-guest-page-content without-actionsbar">
                <div className="row">
                   <FormattedMessage id="ToTakeAdvantageOfExclusiveOffers"/>
                </div>

                <div className="row btn-row">
                    <button onClick={() => toLoginPage()} className="btn btn-default btn-xl uppercase" data-qa="login-or-continue-as-guest-go-to-login-btn">
                        <FormattedMessage id="LogIn"/></button>
                </div>

                <div className="row">
                    <a onClick={(e) => continueAsGuest(e)} className="btn-link blue underlined" data-qa="continue-as-guest-btn"><FormattedMessage
                        id="OrderAsGuest" defaultMessage="OrderAsGuest"/></a>
                </div>

            </main>
        </>
    );
}

export default LoginOrContinueAsGuest;
